export default "__VITE_ASSET__Cbk_oHT0__"